import React, { useRef, useState } from "react";

export const PhotoGallery = ({ images, alt, testId }) => {
  const [i, setI] = useState(0);
  const touch = useRef({ x: 0, swiped: false });
  const next = () => setI((p) => (p + 1) % images.length);
  const prev = () => setI((p) => (p - 1 + images.length) % images.length);

  const onTouchStart = (e) => {
    touch.current = { x: e.touches[0].clientX, swiped: false };
  };
  const onTouchEnd = (e) => {
    const dx = e.changedTouches[0].clientX - touch.current.x;
    if (Math.abs(dx) > 40) {
      touch.current.swiped = true;
      if (dx < 0) next(); else prev();
    }
  };
  const onClick = () => {
    if (touch.current.swiped) { touch.current.swiped = false; return; }
    next();
  };

  const single = images.length < 2;

  return (
    <div className="photo-gallery" data-testid={testId}>
      <button
        type="button"
        className="photo-gallery-frame"
        onClick={single ? undefined : onClick}
        onTouchStart={single ? undefined : onTouchStart}
        onTouchEnd={single ? undefined : onTouchEnd}
        aria-label={single ? alt : `${alt} — photo ${i + 1} of ${images.length}, tap for next`}
        data-testid={`${testId}-frame`}
      >
        <img src={images[i]} alt={`${alt} — view ${i + 1}`} draggable={false} data-testid={`${testId}-img`} />
      </button>
      {!single && (
        <>
          <div className="photo-gallery-meta">
            <div className="photo-gallery-dots">
              {images.map((_, d) => (
                <button
                  key={d}
                  type="button"
                  className={`photo-gallery-dot ${d === i ? "on" : ""}`}
                  onClick={() => setI(d)}
                  aria-label={`View photo ${d + 1}`}
                  data-testid={`${testId}-dot-${d}`}
                />
              ))}
            </div>
            <span className="photo-gallery-count" data-testid={`${testId}-count`}>{i + 1} / {images.length}</span>
          </div>
          <div className="photo-gallery-hint">Tap to flip through — swipe on mobile</div>
        </>
      )}
    </div>
  );
};
